export enum EEventType {
    // AppContainer_DataChanged,
    Dreams_DataChanged,
    GoalsContainer_DataChanged,
    Log_LogData_Changed,
    KeyValueLogs_DataChanged,
    ShowCurrentEnergy_valueChanged,
    Workflows_RootNodeChange_FinishLoading,
    Workflows_RootNodeChange_StartLoading,
    Workflows_DataChanged,
    Workflows_Mounted,
}
